<template>
  <div>
    <el-page-header @back="goBack" content="提成方案成功" class="header"></el-page-header>
    <div class="content-wapper">
      <div class="success-wapper">
        <img src="@/assets/u97.png" alt="success">
        <p>方案提交成功，你可以 <span class="link" @click="goDetail">查看方案</span>，或 <span class="link" @click="goBack">返回列表页</span></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: this.$route.query.id,
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        path: '/points-plan-list'
      })
    },
    goDetail(){
      this.$router.push({
        path: '/points-plan-detail',
        query:{
          id:this.id,
        }
      })
    },
  }
}

</script>

<style scoped>
.wapper {
  padding: 15px;
}
table{
  border-collapse: separate;
}
.header {
  margin-bottom: 15px;
}

.content-wapper {
  border: 1px solid #d6dbe5;
  border-radius: 3px;
  padding: 30px;
  padding-top: 15px;
  background: #fff;
}
.link{
  color: #409EFF;
  cursor: pointer;
}
.success-wapper{
  text-align: center;
}
.success-wapper p{
  text-align: center;
  font-size: 16px;
  margin-top: 22px;
}
</style>